<template>
  <v-container>
    <!-- Home > Store -->
    <v-breadcrumbs
      class="pl-1 py-2"
      divider=">"
      :items="breadcrumb"
    ></v-breadcrumbs>
    <v-row align="center" no-gutters style="height: 40px">
      <!-- Back Button -->
      <v-btn text small class="px-1" @click="$router.go(-1)"
        ><v-icon left small> mdi-chevron-left </v-icon
        >{{ $langs.Gen.goBack[$langs.lang] }}</v-btn
      >

      <v-spacer></v-spacer>

      <!--Search Storeยังไม่ได้ทำ-->
    </v-row>

    <!-- FOLLOWED STORES -->
    <div v-if="!!followedStores.length" class="mb-8">
      <v-row class="px-4 my-2" align="center" no-gutters>
        <v-divider class="bold-1"></v-divider>
        <span class="text-h6 px-4 text-capitalize">Favorite Stores</span>
        <v-divider class="bold-1"></v-divider>
      </v-row>
      <div
        class="list-item"
        v-for="store in followedStores"
        :key="`f${store._id}`"
      >
        <StoreItem class="d-block mx-auto" :store="store" />
      </div>
    </div>

    <!-- PAGE TITLE -->
    <v-row class="px-4 my-2" align="center" no-gutters>
      <v-divider class="bold-1"></v-divider>
      <span class="text-h6 px-4 text-capitalize">All Store</span>
      <v-divider class="bold-1"></v-divider>
    </v-row>

    <!-- FILTER BY ALPHABET -->
    <v-slide-group show-arrows center-active class="mb-4" :value="letter">
      <v-slide-item
        v-for="(c, i) in alphabet"
        :key="i"
        :value="c"
        v-slot="{ active, toggle }"
      >
        <v-btn
          small
          class="ma-1 px-2 white"
          :class="{ 'ml-auto': i == 0, 'mr-auto': i == 25 }"
          active-class="primary white--text"
          style="min-width: 0"
          :input-value="active"
          :ripple="false"
          @click="
            toggle();
            filterLetter(c, !active);
          "
        >
          {{ c }}
        </v-btn>
      </v-slide-item>
    </v-slide-group>

    <!-- Store list -->
    <div class="list-item" v-for="store in stores" :key="store._id">
      <StoreItem class="d-block mx-auto" :store="store" />
    </div>

    <v-pagination
      v-if="!!pageCount"
      class="my-4"
      :length="pageCount"
      v-model="PAGE"
      :total-visible="visiblePagination[$vuetify.breakpoint.name]"
      @input="goPage"
    ></v-pagination>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import StoreItem from "@/components/base/StoreItem";
import api from "../services/api";
import user from "../services/user";

export default {
  name: "StoreList",
  data() {
    return {
      breadcrumb: [
        { text: this.$langs.Gen.home[this.$langs.lang], to: "/" },
        { text: this.$langs.Gen.stores[this.$langs.lang], to: "/stores" },
      ],
      stores: [],
      followedStores: [],
      pageCount: 0,
      visiblePagination: { xs: 4, sm: 6, md: 9, lg: 11 },
      ITEM_PER_PAGE: 60,
      PAGE: 1,
      alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),
      letter: null,
      isLoadingFollowedStore: false,
    };
  },
  components: {
    StoreItem,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.isLogged) vm.getFollowedStore();
    });
  },
  mounted() {
    this.letter = this.$route.query.l;
    if (this.$route.query.page) this.PAGE = parseInt(this.$route.query.page);
    else if (this.isLogged && !this.isLoadingFollowedStore)
      this.getFollowedStore();
    this.getStoreList();
    // for (let i=0; i < 9; i++) this.stores.push({});
  },
  methods: {
    async getStoreList() {
      let params = {
        count: this.pageCount == 0,
        page: this.PAGE,
        size: this.ITEM_PER_PAGE,
      };
      if (this.letter) params.letter = this.letter;
      // let _data = api.getCacheStores(params);
      // if (_data) {
      //   if (_data.amount) this.pageCount = Math.ceil(amount / this.ITEM_PER_PAGE);
      //   this.stores = _data.stores;
      // }
      let data = await api.getStoreList(params);
      if (!data) return;
      let { stores, amount } = data;
      if (amount) this.pageCount = Math.ceil(amount / this.ITEM_PER_PAGE);
      this.stores = stores;
    },
    filterLetter(c, active) {
      if (!active) c = undefined;
      let page = undefined;
      this.$router.push({ query: { ...this.$route.query, page, l: c } });
      // this.pageCount = 0;
      // this.getStoreList();
    },
    goPage(page) {
      if (page == 1) page = undefined;
      this.$router.push({ query: { ...this.$route.query, page } });
      // this.getStoreList();
    },
    async getFollowedStore() {
      this.isLoadingFollowedStore = true;
      let { stores } = await user.getFollowedStore();
      this.isLoadingFollowedStore = false;
      if (stores) this.followedStores = stores;
    },
  },
  computed: {
    ...mapState(["userInfo", "isLogged"]),
  },
  metaInfo() {
    return {
      title: "Stores",
      titleTemplate: "%s · Marketpett",
      // meta: [
      //   {
      //     vmid: "description",
      //     name: "description",
      //     content: "Marketpett",
      //   },
      // ],
    };
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  // background: red;
  display: inline-block;

  @media only screen and (min-width: 100px) {
    width: 50%;
  }

  @media only screen and (min-width: 475px) {
    width: 33%;
  }

  @media #{map-get($display-breakpoints, 'sm-and-up' )} {
    // background: green;
    width: 33%;
  }

  @media only screen and (min-width: map-get($grid-breakpoints, "sm" )) and (max-width: 700px) {
  }

  @media #{map-get($display-breakpoints, 'md-and-up' )} {
    // background: blue;
    width: 25%;
  }
  @media #{map-get($display-breakpoints, 'lg-and-up' )} {
    // background: chartreuse;
    width: 20%;
  }
}
</style>